var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.stepContainer)},[_c('div',{staticClass:"w-full flex justify-center"},[_c('span',{},[_vm._v(_vm._s(_vm.getMeasureStep + 1)+" / "+_vm._s(_vm.getAreaLength))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }